<template>
    <div>
        <div v-if="user != undefined && user.id != undefined && getToken != undefined" @click.self="reply_comment_id = undefined">
            <div class="createComment">
                <div class="comment-user-info">
                    <b-img rounded="circle" class="comment-user-pic"
                            :src="get_UserPic(user.pic)" :alt="user.first_name + ' ' + user.last_name"></b-img>
                    <div class="comment-user-name">
                        {{ user.first_name }} {{ user.last_name }}
                    </div>
                </div>
                <div class="comment-box">
                    <b-input-group>
                        <b-form-textarea type="text" v-model="new_comment" class=""></b-form-textarea>
                        <b-input-group-append>
                            <b-button variant="success" @click="create_Comment('create')" :disabled="checkDisabled_new">
                                <i class="fa fa-plus block-text"></i>{{ $t('menu.new_comment') }}
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>

            </div>
            <div class="commentList">
                <div v-if="loading"><AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading></div>
                <div v-else><b-button variant="warning" @click="get_Comments">{{ $t('menu.refresh_data') }}</b-button></div>
                
                <div v-if="list_comments.length > 0">
                    <div class="comment-root" v-for="( com_parent, idx_cp ) in list_comments" :key="idx_cp">
                        <div>
                            <!-- 回饋第一層 -->
                            <div class="comment-user-info">
                                <b-img rounded="circle" class="comment-user-pic"
                                        :src="get_UserPic(com_parent.user.pic)" :alt="com_parent.user.first_name + ' ' + com_parent.user.last_name"></b-img>
                                <div class="comment-user-name">
                                    {{ com_parent.user.first_name }} {{ com_parent.user.last_name }}
                                    <span class="comment-user-role">
                                        <i :class="$tools.style.classRoleIcon(com_parent.user.user_role)"></i>{{ $t('n.' + com_parent.user.user_role ) }}
                                    </span>
                                </div>
                            </div>
                            <div class="comment-content">
                                
                                <div class="comment-body">
                                    <div class="comment-time">
                                        {{ com_parent.created_at }}
                                        <span v-if="com_parent.created_at != com_parent.updated_at">( {{ $t('menu.edited') }} )</span>
                                    </div>
                                    {{ com_parent.body }}
                                </div>
                                
                                <div class="comment-content">
                                    <b-button variant="success" size="sm" class="btn-comment"
                                             v-if="edit_comment_id != com_parent.id"
                                            @click="switch_reply( com_parent.id )">
                                        <i class="fa fa-plus"></i>{{ $t('menu.reply') }}
                                    </b-button>

                                    <template v-if="check_UserEditable(com_parent.user_id)">
                                        <span v-if="edit_comment_id != com_parent.id">
                                            <b-button
                                                    variant="primary" size="sm" class="btn-comment"
                                                    @click="switch_edit( com_parent.id, com_parent.body )">
                                                <i class="fa fa-pencil"></i>{{ $t('menu.editting') }}
                                            </b-button>
                                            <b-button variant="danger" size="sm" class="btn-comment"
                                                    @click="delet_comment( com_parent.id )">
                                                <i class="fa fa-times"></i>{{ $t('menu.delete') }}
                                            </b-button>
                                        </span>
                                    </template>
                                </div>
                            </div>
                            <!-- 編輯輸入框 -->
                            <div class="reply-box" v-if="edit_comment_id == com_parent.id">
                                <b-input-group>
                                    <b-form-textarea v-model="edit_comment" :autofocus="true"></b-form-textarea>
                                    <b-input-group-append>
                                        <b-button variant="success" :disabled="checkDisabled_edit" @click="update_comment( com_parent.id )">
                                            {{ $t('menu.confirm') }}
                                        </b-button>
                                        <b-button variant="secondary" @click="switch_cancel">{{ $t('menu.cancel') }}</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                            
                        </div>

                        
                        <div class="comment-child">
                            <!-- 回饋第二層：(回饋的回饋) -->
                            <div v-for="( com_child, idx_cc ) in com_parent.replies" :key="idx_cc" class="comment-line">
                                <div class="comment-user-info">
                                    <b-img rounded="circle" class="comment-user-pic"
                                            :src="get_UserPic(com_child.user.pic)" :alt="com_child.user.first_name + ' ' + com_child.user.last_name"></b-img>
                                    <div class="comment-user-name">
                                        {{ com_child.user.first_name }} {{ com_child.user.last_name }}
                                        <span class="comment-user-role">
                                            <i :class="$tools.style.classRoleIcon(com_child.user.user_role)"></i>{{ $t('n.' + com_child.user.user_role ) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="comment-content">
                                    
                                    <div class="comment-body">
                                        <div class="comment-time">
                                            {{ com_child.created_at }}
                                            <span v-if="com_child.created_at != com_child.updated_at">( {{ $t('menu.edited') }} )</span>
                                        </div>
                                        {{ com_child.body }}
                                    </div>

                                    <div class="comment-content" v-if="check_UserEditable(com_child.user_id)">
                                        <span v-if="edit_comment_id != com_child.id">
                                            <b-button
                                                    variant="primary" size="sm" class="btn-comment"
                                                    @click="switch_edit( com_child.id, com_child.body )">
                                                <i class="fa fa-pencil"></i>{{ $t('menu.editting') }}
                                            </b-button>
                                            <b-button variant="danger" size="sm" class="btn-comment"
                                                    @click="delet_comment( com_child.id )">
                                                <i class="fa fa-times"></i>{{ $t('menu.delete') }}
                                            </b-button>
                                        </span>
                                    </div>
                                </div>
                                <!-- 編輯輸入框 -->
                                <b-row v-if="edit_comment_id == com_child.id">
                                    <b-col md="10">
                                        <b-input-group class="reply-box">
                                            <b-form-textarea v-model="edit_comment" :autofocus="true"></b-form-textarea>
                                            <b-input-group-append>
                                                <b-button variant="success" :disabled="checkDisabled_edit" @click="update_comment( com_child.id )">
                                                    {{ $t('menu.confirm') }}
                                                </b-button>
                                                <b-button variant="secondary" @click="switch_cancel">{{ $t('menu.cancel') }}</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </div>
                            <!-- 回饋輸入框 -->
                            <b-row v-if="reply_comment_id == com_parent.id">
                                <b-col md="10">
                                    <b-input-group class="reply-box">
                                        <b-form-textarea v-model="reply_comment" :autofocus="true"></b-form-textarea>
                                        <b-input-group-append>
                                            <b-button variant="success" :disabled="checkDisabled_reply" @click="create_Comment('reply')">
                                                <i class="fa fa-plus block-text"></i>{{ $t('menu.new_comment') }}
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        
                        </div>

                    </div>
                </div>
                <div v-else-if="loading == false">
                    <NoData></NoData>
                </div>
            </div>
        </div>
        <div v-else>
            <b-button variant="success" size="lg" :to="{ name: 'Login' }">{{ $t('other.login_to_comment') }}</b-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域
import AgriLoading  from '@/views/components/AgriLoading'
import NoData       from '@/views/components/NoData'

export default {
    props: {
        page_type: {
            type: String,
            default: 'report',
        },
        page_id: {
            type: String,
            require: true,
        },
        user: {
            type: Object,
            default: undefined,
        },
        timezone: {
            type: String,
            default: undefined,
        },
    },
    directives: {
        'dragscroll': dragscroll,
    },
    components: {
        AgriLoading,
        NoData,
    },
    data () {
        return {
            loading: false,
            uploading: false,
            new_comment: '',
            edit_comment: '',
            edit_comment_id: undefined,

            reply_comment: '',
            reply_comment_id: undefined,

            list_comments: [],
        }
    },
    mounted ()
    {
        this.get_Comments()
    },
    computed: {
        ...mapState({
            'default_avatar': state => state.user.default_avatar,
            'user_language': state => state.user.language,
        }),

        getToken ()
        {
            return localStorage.token
        },

        checkDisabled_new ()
        {
            if (this.new_comment == undefined)   return true
            if (this.new_comment == '')          return true
            return this.uploading
        },
        checkDisabled_reply ()
        {
            if (this.reply_comment == undefined)   return true
            if (this.reply_comment == '')          return true
            return this.uploading
        },
        checkDisabled_edit ()
        {
            if (this.edit_comment == undefined)   return true
            if (this.edit_comment == '')          return true
            return this.uploading
        },
    },
    methods: {

        get_UserPic (userPic)
        {
            if (userPic != undefined) return userPic
            return this.default_avatar
        },

        check_UserEditable ( comment_user_id )
        {
            if ( this.user != undefined && this.user.id != undefined )
            {
                if ( this.user.id == comment_user_id ) return true
            }
            return false
        },

        update_comment( comment_id )
        {
            this.uploading = true;
            
            let options = {
                method:'PUT',
                url: this.$config.getAPI_URL('Edit_Comments', { commentID: comment_id }),
                data: { body: this.edit_comment },
            }
            this.$http(options)
            .then( res => {
                
                this.uploading = false;
                this.get_Comments()
                this.$toastr.s( this.$t('other.update_succeeded') );
            })
            .catch( err => {
                // console.clear();
                this.uploading = false;
                this.$toastr.e( this.$t('other.update_failed') );
            })
        },

        delet_comment ( comment_id )
        {
            if ( confirm( this.$t('other.confirm_delete') ) )
            {
                this.uploading = true;

                let options = {
                    method:'DELETE',
                    url: this.$config.getAPI_URL('Edit_Comments', { commentID: comment_id }),
                }
                this.$http(options)
                .then( res => {
                    
                    this.uploading = false;
                    this.get_Comments()
                    this.$toastr.s( this.$t('other.update_succeeded') );
                })
                .catch( err => {
                    // console.clear();
                    this.uploading = false;
                    this.$toastr.e( this.$t('other.update_failed') );
                })
            }
        },

        switch_cancel ()
        {
            // 清除 edit 設定
            this.edit_comment = ''
            this.edit_comment_id = undefined

            // 清除 reply 設定
            this.reply_comment = ''
            this.reply_comment_id = undefined
        },
        switch_reply ( comment_id )
        {
            let _check_id = ( this.reply_comment_id == comment_id ? undefined : comment_id )
            this.switch_cancel()
            
            this.reply_comment_id = _check_id
        },
        switch_edit ( comment_id, comment_body )
        {
            this.switch_cancel()
            this.edit_comment    = comment_body
            this.edit_comment_id = comment_id
        },

        get_Comments ()
        {
            if ( this.getToken != undefined )
            {
                this.loading = true
                this.list_comments = []
                this.switch_cancel()

                const options = {
                    method:'GET',
                    url: this.$config.getAPI_URL('Report_Comments', { reportID: this.page_id }),
                }
                this.$http(options)
                .then( res => {
                    this.loading = false
                    if ( res.data && res.data.comments )
                    {
                        let _all_comments = res.data.comments

                        _all_comments.forEach( _commentRoot => {
                            
                            _commentRoot.created_at = this.$tools.date.dateTimeZone( _commentRoot.created_at, this.timezone, 'YYYY-MM-DD HH:mm' );
                            _commentRoot.updated_at = this.$tools.date.dateTimeZone( _commentRoot.updated_at, this.timezone, 'YYYY-MM-DD HH:mm' );

                            _commentRoot.replies.forEach( _reply => {
                                _reply.created_at = this.$tools.date.dateTimeZone( _reply.created_at, this.timezone, 'YYYY-MM-DD HH:mm' );
                                _reply.updated_at = this.$tools.date.dateTimeZone( _reply.updated_at, this.timezone, 'YYYY-MM-DD HH:mm' );
                            })
                        })

                        this.list_comments = _all_comments
                    }
                })
                .catch( err => {
                    this.loading = false
                })
            }
        },

        create_Comment (type = 'create')
        {
            this.uploading = true;
            
            let options = {}
            if ( type == 'create' )
            {
                options = {
                    method:'POST',
                    url: this.$config.getAPI_URL('Report_Comments', { reportID: this.page_id }),
                    data: { body: this.new_comment },
                }
            }
            else if ( type == 'reply' )
            {
                options = {
                    method:'POST',
                    url: this.$config.getAPI_URL('Edit_Comments', { commentID: this.reply_comment_id }),
                    data: { body: this.reply_comment },
                }
            }

            this.$http(options)
            .then( res => {
                
                this.uploading = false;
                this.get_Comments()
                this.$toastr.s( this.$t('other.update_succeeded') );
            })
            .catch( err => {
                // console.clear();
                this.uploading = false;
                this.$toastr.e( this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message );
            })
        },

    },
}
</script>

<style lang="scss" scoped>

    .comment-user-info
    {
        display: inline-block;
        vertical-align: top;
        margin-top: 5px;
        padding: 2px 10px;
        color: #204e31;
        background-color: #cae4c0;
        // background-color: #f1f1f1;
        border-radius: 30px;
        // height: 35px;

        .comment-user-pic
        {
            display: inline-block;
            vertical-align: middle;
            width: 30px;
            height: 30px;
        }
        .comment-user-name
        {
            display: inline-block;
            vertical-align: middle;
            margin: 5px;
        }
        .comment-user-role
        {
            display: inline-block;
            margin-left: 5px;
            color:#248679;

            i {
                margin-right: 2px;
            }
        }
    }
    .comment-box
    {
        border: 2px solid rgba(20, 113, 73, 0.6);
        border-radius: 5px;
    }
    .reply-box
    {
        border: 1px solid rgba(84, 176, 136, 0.6);
        border-radius: 5px;
    }
    .commentList
    {
        padding: 10px 10px;
    }

    .comment-root
    {
        padding: 5px;
        margin-bottom: 5px;
    }
    .comment-body
    {
        display: inline-block;
    }
    .comment-time
    {
        color:#397f94;
    }
    .comment-line
    {
        margin: 2px;
    }
    .comment-content
    {
        display: inline-block;
        margin: 5px 10px 5px 5px;
    }
    .btn-comment
    {
        padding: 1px 5px;
        margin-right: 5px;
    }
    .comment-child
    {
        // display: inline-block;
        margin-left: 30px;
    }

</style>
